import { localStorageManager } from '@libs/shared';
import { LOCAL_STORAGE } from '../constants';

/**
 * 切换语言
 *
 * @param language
 */
export const switchLanguage = (language: string) => {
    if (language !== localStorageManager.get(LOCAL_STORAGE.LANG)) {
        localStorageManager.set(LOCAL_STORAGE.LANG, language);
    }
};
